module.exports = __webpack_public_path__ + "img/overlay_bg.197a1457.png";